// eslint-disable-next-line camelcase
export default function (date, iso_weekday_ids, holidays_by_workspace, days_off_by_workspace) {
  // Check if the date falls on an ISO weekday
  if (!iso_weekday_ids.includes(date.getUTCDay())) {
    return true
  }

  // Check if the date falls on a holiday
  const holidayDates = holidays_by_workspace.map(holiday => new Date(holiday))
  if (holidayDates.some(holiday => holiday.toISOString().slice(0, 10) === date.toISOString().slice(0, 10))) {
    return true
  }

  // Check if the date falls on a day off
  const dayOffDates = days_off_by_workspace.map(dayOff => new Date(dayOff))
  if (dayOffDates.some(dayOff => dayOff.toISOString().slice(0, 10) === date.toISOString().slice(0, 10))) {
    return true
  }

  // If the date has passed all checks, it's a workday
  return false
}
